import { type PropsWithChildren } from 'react'
import { type ItemListSearchParams } from '../../../Common/ItemList/ItemList'
import BaseProductSearchBar, { type ProductSearchFilterOption } from '../../Products/BaseProductSearchBar'

export interface StoreProductSearchParams extends ItemListSearchParams {
  productTypes: string[]
  search: string[]
}

type Props = PropsWithChildren<{
  placeholder?: string
  value?: StoreProductSearchParams
  onChange?: (value: (value: StoreProductSearchParams) => StoreProductSearchParams) => void
  filterOptions?: ProductSearchFilterOption[]
}>

export default function StoreProductSearchBar(props: Props) {
  return <BaseProductSearchBar
    placeholder={props.placeholder}
    value={props.value}
    onChange={props.onChange}
    filterField="productTypes"
    filterOptions={props.filterOptions ?? []}
  >
    {props.children}
  </BaseProductSearchBar>
}
